import { produce } from "immer";
import { onboardingTypes as types } from "../actions";
import { EducatorOnboardingStateType } from "../../../utils";

const defaultState: EducatorOnboardingStateType = {
  onboardings: [],
  onboarding: null,
  loading: false,
  loaded: false,
};

const handleSetOnboardings = (state: any, payload: any) => {
  state.onboardings = payload.onboardings;
  state.loading = false;
  state.loaded = true;
  return state;
};

const handleSetOnboardingById = (state: any, payload: any) => {
  state.onboarding = payload.onboarding;
  state.loading = false;
  return state;
};

export default produce(
  (state: EducatorOnboardingStateType = defaultState, action) => {
    switch (action.type) {
      case types.SET_ONBOARDING:
        return handleSetOnboardings(state, action.payload);
      case types.SET_ONBOARDING_BY_ID:
        return handleSetOnboardingById(state, action.payload);
      case types.GET_ONBOARDING:
        return {
          ...state,
          loading: true,
        };
      case types.GET_ONBOARDING_BY_ID:
        return {
          ...state,
          loading: true,
        };
      case types.IS_LOADING:
        return {
          ...state,
          loading: action.payload,
        };
      default:
        return state;
    }
  }
);
